/* <text fill="white" text-anchor="middle"
x="${node.width / 2}" y="${node.height / 2 + 25}">
${node.familyMember.name}
</text>

<path d="${topStrokePath}" stroke="red" stroke-width="10" fill="none"/>*/

// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails";
import "./controllers";
import "justified-layout"
import { Fancybox } from "@fancyapps/ui";

import "trix"
import "@rails/actiontext"




function getQueryParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

document.addEventListener("turbo:load", function() {
    let options = {
        Toolbar: {
            display: {
                left: ["infobar"],
                middle: [],
                right: ["slideshow", "download", "thumbs", "close"],
            },
        },
    };

    Fancybox.bind('[data-fancybox]', options);
});
